import { schema as normalizrSchema } from 'normalizr';
import { schema as message } from './message';

export const schema = new normalizrSchema.Entity('chat', {
    messages: [message],
});
export const schemasArray = new normalizrSchema.Array(schema);